import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects"; // if you use effects
import { StoreDevtoolsModule } from "@ngrx/store-devtools"; // devtools

import { rootReducer, ArchitectUIState } from "./ThemeOptions/store";
import { ConfigActions } from "./ThemeOptions/store/config.actions";
import { AppRoutingModule } from "./app-routing.module";

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { TokenInterceptorService } from "./Helpers/TokenInterceptorService";

import { CommonModule, DatePipe } from "@angular/common";
import { AppComponent } from "./app.component";
/* import {
  RECAPTCHA_SETTINGS,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaV3Module,
} from "ng-recaptcha"; */
import { environment } from "../environments/environment";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { RoundProgressModule } from "angular-svg-round-progressbar";
import { ToastrModule } from "ngx-toastr";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { NgSelectModule } from "@ng-select/ng-select";
import { SelectDropDownModule } from "ngx-select-dropdown";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { AngularEditorModule } from "@kolkov/angular-editor";

// import { ClipboardModule } from "ngx-clipboard";
import { ColorPickerComponent } from "ngx-color-picker";
import { DropzoneModule } from "ngx-dropzone-wrapper";
import { DROPZONE_CONFIG } from "ngx-dropzone-wrapper";
import { DropzoneConfigInterface } from "ngx-dropzone-wrapper";
import { NgChartsModule, ThemeService } from "ng2-charts";
import { RichTextEditorModule } from "@syncfusion/ej2-angular-richtexteditor";

import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatMenuModule } from "@angular/material/menu";
import { MatListModule } from "@angular/material/list";
import { MatStepperModule } from "@angular/material/stepper";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTreeModule } from "@angular/material/tree";
import {
  MAT_RADIO_DEFAULT_OPTIONS,
  MatRadioModule,
} from "@angular/material/radio";

import { BaseLayoutComponent } from "./Layout/base-layout/base-layout.component";
import { AppsLayoutComponent } from "./Layout/apps-layout/apps-layout.component";
import { PagesLayoutComponent } from "./Layout/pages-layout/pages-layout.component";
import { ThemeOptions } from "./theme-options";
import { OptionsDrawerComponent } from "./ThemeOptions/options-drawer/options-drawer.component";
import { PageTitleComponent } from "./Layout/Components/page-title/page-title.component";

import { HeaderComponent } from "./Layout/Components/header/header.component";
import { DotsComponent } from "./Layout/Components/header/elements/dots/dots.component";
import { SearchBoxComponent } from "./Layout/Components/header/elements/search-box/search-box.component";
import { MegamenuComponent } from "./Layout/Components/header/elements/mega-menu/mega-menu.component";
import { MegapopoverComponent } from "./Layout/Components/header/elements/mega-menu/elements/megapopover/megapopover.component";
import { UserBoxComponent } from "./Layout/Components/header/elements/user-box/user-box.component";
import { DrawerComponent } from "./Layout/Components/header/elements/drawer/drawer.component";

import { SidebarComponent } from "./Layout/Components/sidebar/sidebar.component";
import { LogoComponent } from "./Layout/Components/sidebar/elements/logo/logo.component";

import { FooterComponent } from "./Layout/Components/footer/footer.component";
import { FooterDotsComponent } from "./Layout/Components/footer/elements/footer-dots/footer-dots.component";
import { FooterMenuComponent } from "./Layout/Components/footer/elements/footer-menu/footer-menu.component";

import { IntlTelInputDirective } from "./intl-tel-input.directive";

import { NgApexchartsModule } from "ng-apexcharts";

import { GaugeModule } from "angular-gauge";
import { TrendModule } from "ngx-trend";
import { CommonModalComponent } from "./Pages/Modals/common-modal/common-modal.component";
import { OverlayscrollbarsModule } from "overlayscrollbars-ngx";
import { RouterModule } from "@angular/router";
import { NgbNavModule } from "@ng-bootstrap/ng-bootstrap";

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  url: "https://httpbin.org/post",
  maxFilesize: 50,
};

import {
  TranslateModule,
  TranslateLoader,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient, HttpClientModule } from "@angular/common/http";

import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { LoginBoxedComponent } from "./Pages/login-boxed/login-boxed.component";
import { CompanyRegistrationComponent } from "./Pages/company-registration/company-registration.component";
import { UserManagementComponent } from "./Pages/user-management/user-management.component";
import { DashboardComponent } from "./Pages/dashboard/dashboard.component";
import { ForgotPasswordComponent } from "./Pages/forgot-password/forgot-password.component";
import { ProjectDetailComponent } from "./Pages/project-detail/project-detail.component";
import { ScreenDetailComponent } from "./Pages/screen-detail/screen-detail.component";
import { ScreenDetailEditComponent } from "./Pages/screen-detail-edit/screen-detail-edit.component";
import { DynamicTooltipFormComponent } from "./Pages/screen-detail-edit/dynamic-tooltip-form/dynamic-tooltip-form.component";
import { DynamicWorkflowFormComponent } from "./Pages/screen-detail-edit/dynamic-workflow-form/dynamic-workflow-form/dynamic-workflow-form.component";
import { DynamicWorkflowStepFormComponent } from "./Pages/screen-detail-edit/dynamic-workflow-step-form/dynamic-workflow-step-form/dynamic-workflow-step-form.component";
import { DeleteConfirmationDialogComponent } from "./Pages/delete-confirmation-dialog/delete-confirmation-dialog.component";
import { AddEditScreenComponent } from "./Pages/screen-detail/add-edit-screen/add-edit-screen.component";
import { DynamicFaqFormComponent } from "./Pages/screen-detail-edit/dynamic-faq-form/dynamic-faq-form.component";
import { DynamicUserguideFormComponent } from "./Pages/screen-detail-edit/dynamic-userguide-form/dynamic-userguide-form.component";
import { DeactiveConfirmComponent } from "./Pages/deactive-confirm/deactive-confirm.component";
import { CanDeactivateGuard } from "./guards/can-deactivate.guard";
import { ThankyouPageComponent } from "./Pages/thankyou-page/thankyou-page.component";
import { SetPasswordComponent } from "./Pages/set-password/set-password.component";
import { TranslationComponent } from "./Pages/translation/translation.component";
import { WorkflowTranslationComponent } from "./Pages/translation/workflow-translation/workflow-translation.component";
import { FaqTranslationComponent } from "./Pages/translation/faq-translation/faq-translation.component";
import { UserguideTranslationComponent } from "./Pages/translation/userguide-translation/userguide-translation.component";
import { AddEditTranslationComponent } from "./Pages/translation/add-edit-translation/add-edit-translation.component";
import { AuditlogComponent } from "./Pages/audit-log/auditlog.component";
import { HistoryModuleComponent } from "./Pages/screen-detail-edit/history-module/history-module.component";
import { ActiveLicensesComponent } from "./Pages/active-licenses/active-licenses.component";
import { AddRenewLicenseComponent } from "./Pages/add-renew-license/add-renew-license.component";
import { RemainingDaysPipe } from "./Pipes/remaining-days.pipe";
import { PaymentPlansComponent } from "./Pages/payment-plans/payment-plans.component";
import { UserBoxLoginComponent } from "./Layout/Components/header/elements/user-box-login/user-box-login.component";
import { PaymentPlansActions } from "./ThemeOptions/store/payment-plans.actions";
import { TransactionDetailComponent } from "./Pages/transaction-detail/transaction-detail.component";
import { UsageAnaylticsComponent } from "./Pages/usage-anayltics/usage-anayltics.component";
import { UsageAnalyticDetailComponent } from "./Pages/usage-anayltics/usage-analytic-detail/usage-analytic-detail.component";
import { UsageAnalyticDetailsComponent } from "./Pages/usage-anayltics/usage-analytic-details/usage-analytic-details.component";
import { NavNodeComponent } from "./Pages/usage-anayltics/nav-node/nav-node.component";
import { NavTreeComponent } from "./Pages/usage-anayltics/nav-tree/nav-tree.component";
import { NavMindtreeComponent } from "./Pages/usage-anayltics/nav-mindtree/nav-mindtree.component";
import { NavFlowComponent } from "./Pages/usage-anayltics/nav-flow/nav-flow.component";
import { TokenExpiredComponent } from "./Pages/token-expired/token-expired.component";
import { ListOfAllCompaniesComponent } from "./Pages/list-of-all-companies/list-of-all-companies.component";
import { MatTabsModule } from "@angular/material/tabs";
import { NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
import {
  FontAwesomeModule,
  FaIconLibrary,
} from "@fortawesome/angular-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { GenerateAiContentComponent } from "./Modals/generate-ai-content/generate-ai-content.component";
import { LiveprojectsComponent } from "./Pages/liveprojects/liveprojects.component";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { VisitedPagesComponent } from "./Pages/screen-detail/visted-pages/visited-pages.component";
//
export function translateModuleFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    IntlTelInputDirective,
    AppComponent,
    BaseLayoutComponent,
    AppsLayoutComponent,
    PagesLayoutComponent,
    OptionsDrawerComponent,
    PageTitleComponent,
    RemainingDaysPipe,
    PaymentPlansComponent,
    UserBoxLoginComponent,
    HeaderComponent,
    DotsComponent,
    SearchBoxComponent,
    MegamenuComponent,
    MegapopoverComponent,
    UserBoxComponent,
    DrawerComponent,
    ActiveLicensesComponent,
    AddRenewLicenseComponent,
    SidebarComponent,
    LogoComponent,
    FooterComponent,
    FooterDotsComponent,
    FooterMenuComponent,
    ForgotPasswordComponent,
    CommonModalComponent,
    CompanyRegistrationComponent,
    UserManagementComponent,
    DashboardComponent,
    ProjectDetailComponent,
    ScreenDetailComponent,
    ScreenDetailEditComponent,
    DynamicTooltipFormComponent,
    DynamicWorkflowFormComponent,
    DynamicWorkflowStepFormComponent,
    DeleteConfirmationDialogComponent,
    UsageAnalyticDetailComponent,
    UsageAnalyticDetailsComponent,
    AddEditScreenComponent,
    DynamicFaqFormComponent,
    DynamicUserguideFormComponent,
    DeactiveConfirmComponent,
    ThankyouPageComponent,
    SetPasswordComponent,
    TranslationComponent,
    WorkflowTranslationComponent,
    FaqTranslationComponent,
    UserguideTranslationComponent,
    AddEditTranslationComponent,
    AuditlogComponent,
    HistoryModuleComponent,
    TransactionDetailComponent,
    UsageAnaylticsComponent,
    NavNodeComponent,
    NavTreeComponent,
    NavMindtreeComponent,
    NavFlowComponent,
    TokenExpiredComponent,
    ListOfAllCompaniesComponent,
    GenerateAiContentComponent,
    LiveprojectsComponent,
    VisitedPagesComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    /*  RecaptchaModule,
    RecaptchaFormsModule,
    RecaptchaV3Module, */
    NgbAccordionModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatTabsModule,
    CommonModule,
    RichTextEditorModule,
    NgbModule,
    NgbTooltipModule,
    LoginBoxedComponent,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    RoundProgressModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      countDuplicates: false,
    }),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    MatButtonToggleModule,
    MatSlideToggleModule,
    NgSelectModule,
    RouterModule,
    SelectDropDownModule,
    NgMultiSelectDropDownModule.forRoot(),
    AngularEditorModule,
    OverlayscrollbarsModule,
    ClipboardModule,
    ColorPickerComponent,
    DropzoneModule,
    NgChartsModule,
    NgApexchartsModule,
    GaugeModule.forRoot(),
    StoreModule.forRoot(),
    StoreDevtoolsModule.instrument(),
    TrendModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatMenuModule,
    MatListModule,
    MatStepperModule,
    MatExpansionModule,
    MatIconModule,
    MatDialogModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatTreeModule,
    MatRadioModule,
    NgbNavModule,
    MatTooltipModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateModuleFactory,
        deps: [HttpClient],
      },
    }),
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    { provide: DROPZONE_CONFIG, useValue: DEFAULT_DROPZONE_CONFIG },
    ConfigActions,
    ThemeOptions,
    DatePipe,
    ThemeService,
    PaymentPlansActions,
    TranslateService,
    CanDeactivateGuard,
    /*  {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey,
      } as RecaptchaSettings,
    }, */
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: "primary" },
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModuleCommon {
  constructor(private library: FaIconLibrary) {
    this.library.addIconPacks(fas, far);
  }
  /* private ngRedux: NgRedux<ArchitectUIState>,
  private devTool: DevToolsExtension */
  /*  this.ngRedux.configureStore(
      rootReducer,
      {} as ArchitectUIState,
      [],
      [devTool.isEnabled() ? devTool.enhancer() : (f) => f]
    ); */
}
